import { apiClient } from '../../common/ApiClient';
import { keepStaleInMinutes } from '../../common/queryClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataSourceUrl } from './DataSourceUrl';

const getDataSourceConnections = () =>
  apiClient
    .get<{ connectionId: string }[]>(DataSourceUrl.CONNECTIONS)
    .then((response) => response.data);

export const useDataSourceConnectionsQuery = createApiQueryHook(
  ['dataSourceConnections'],
  getDataSourceConnections,
  keepStaleInMinutes(5)
);
